export const INPLAY_APP_WRAPPER_CSS_ID = 'bb-inplay-app';
export const CLASS_BLOCK_NAME = 'bb-inplay';

export const EVENTS_ENDPOINT = '/inplay-req/getInplayEvents';
export const SCHEDULED_EVENTS_ENDPOINT = '/inplay-req/getScheduledEvents';
export const SELECTION_REORDER_ENDPOINT = '/inplay-req/market_selections_ordering';

export const DEFAULT_NUMBER_OF_EXPANDED_SPORTS = 3;

export const I18N_PREFIX = 'inplay';
export const INPLAY_ERROR = {
    GENERIC: 0,
    NO_LIVE_EVENTS: 1,
    NO_SCHEDULED_EVENTS: 2,
};

export const INPLAY_URL_ROOT = 'inplay';

export const DEFAULT_SCHEDULED_EVENTS_DATE = 'today';

export const SCHEDULED_UP_NEXT = 'up_next';
export const SCHEDULED_TODAY = 'today';

export const INDEX_ROUTE = 'all';
export const SCHEDULED_ROUTE = 'scheduled';
export const VIRTUAL_SPORTS_ROUTE = 'virtual-sports';
export const FOOTBALL_SLUG = 'football';
export const BASKETBALL_SLUG = 'basketball';
export const RUGBY_SLUG = 'rugby';
export const GOLF_SLUG = 'golf';
export const TENNIS_SLUG = 'tennis';
export const DARTS_SLUG = 'darts';
export const AMERICAN_FOOTBALL_SLUG = 'american-football';
export const BOXING_SLUG = 'boxing';
export const SNOOKER_SLUG = 'snooker';
export const CRICKET_SLUG = 'cricket';
export const TEST_CRICKET_SLUG = 'test-cricket';
export const BASEBALL_SLUG = 'baseball';
export const ICE_HOCKEY_SLUG = 'ice-hockey';
export const RUGBY_LEAGUE_SLUG = 'rugby-league';
export const RUGBY_UNION_SLUG = 'rugby-union';
export const GAA_FOOTBALL_SLUG = 'gaa-football';
export const GAA_HURLING_SLUG = 'gaa-hurling';
export const HANDBALL_SLUG = 'handball';
export const ALL_SPORTS_SLUG = 'all-sports';
export const SCHEDULE_SLUG = 'schedule';
export const VOLLEYBALL_SLUG = 'volleyball';
export const ESPORTS_SLUG = 'esports';
export const TABLE_TENNIS_SLUG = 'table-tennis';

export const EVENT_STARTED_EVENT = 'inplay:event:started';
export const INPLAY_ERROR_EVENT = 'inplay:error';
export const EVENT_ENDED_EVENT = 'inplay:event:ended';
export const SPORT_REMOVED_EVENT = 'inplay:sport:removed';
export const SCHEDULED_EVENTS_LOADED_EVENT = 'inplay:scheduled:events:loaded';
export const ROUTE_CHANGED_EVENT = 'inplay:route:changed';
export const EVENTS_RETRIVED = 'inplay:event:retrived';

/*
 * The constant OUTRIGHTS_WIN_ONLY_MARKET_NAME was copied from Golf Inplay
 * GroupedParticipantsLayout/constants.js
 * It used as a key to identify an Outright Winner Market
 **/
export const OUTRIGHTS_WIN_ONLY_MARKET_NAME = 'Outright - Winner Each Way';
export const OUTRIGHTS_WIN_ONLY_MARKET_CLASS = 'bb-outright-winner-market';
export const OUTRIGHT_ONLY_IN_ALL_SPORTS = ['golf'];

export const SCHEDULED_DATE_REGEXP = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}/;
export const SELECTED_TOPMENU_TAB_REGEXP = /[^/]+(?=\/$|$)/;

export const WS_HANDLER_COMPONENT_NAME = 'InplayMain';

import { VIRTUAL_GENERIC_SLUG_MAPPINGS } from '~spa/Pages/VirtualSports/constants';
export const SPORTS_SLUG_TO_VIRTUALS_MAP = VIRTUAL_GENERIC_SLUG_MAPPINGS;

export const TAB_INDEX = {
    LIVE_NOW: 0,
    SCHEDULED: 1,
};
